import { getStrapiData, processStrapiData, createStrapiAxiosInstance } from './strapiuniversalservice';

export const getImageModals = async () => {
  const { data, error } = await getStrapiData('/content/modals?populate=*');

  if (error) {
    console.error('Erro ao carregar os modais:', error);
    return { data: null, error: null };
  }

  return { data: data?.data || null, error: null };
};

export const getAlerts = async () => {
  const { data, error } = await getStrapiData('/content/messages?populate=*');
  if (error) return { data: [], error: null };

  try {
    if (!data || !data.data) {
      return { data: [], error: null };
    }

    const mappedData = data.data.map(item => ({
      id: item.id,
      documentId: item.documentId,
      content: item.content,
      color: item.color,
      startDate: item.startDate,
      endDate: item.endDate
    }));

    return { data: mappedData, error: null };
  } catch (err) {
    console.warn('Erro ao processar dados de alertas:', err);
    return { data: [], error: null };
  }
};

export const getAlertPIXSales = async () => {
  const url = "/content/aba-venda-pixs?fields[0]=message";
  const { data, error } = await getStrapiData(url);

  if (error || !data?.data) return { message: null };

  try {
    const { message } = data.data.find(item => item.message) || {};
    return { message };
  } catch (err) {
    return { message: null };
  }
};

export const getAlertPIXTip = async () => {
  const url = "/content/aba-gorjeta-vips?fields[0]=message";
  const { data, error } = await getStrapiData(url);

  if (error || !data?.data) return { message: null };

  try {
    const { message } = data.data.find(item => item.message) || {};
    return { message };
  } catch (err) {
    return { message: null };
  }
};

export const getAlertPIXTerms = async () => {
  const url = "/content/aba-termos-e-condicoes?fields[0]=message";
  const { data, error } = await getStrapiData(url);

  if (error || !data?.data) return { message: null };

  try {
    const { message } = data.data.find(item => item.message) || {};
    return { message };
  } catch (err) {
    return { message: null };
  }
};
export const getInformativoWhatsapps = async () => {
  const url = "/content/informativo-whatsapps?fields[0]=title&fields[1]=message&fields[2]=buttonLabel&fields[3]=buttonUrl";
  const { data, error } = await getStrapiData(url);

  if (error) return null;

  if (data?.data?.length > 0) {
    return data.data;
  }

  return null;
};

export const getAlertResume = async () => {
  const { data, error } = await getStrapiData('/content/resumo-da-solicitacao-da-campanhas?populate=*');

  if (error) {
    return { message: '', startDate: null, endDate: null, error: null };
  }

  if (data?.data?.length > 0) {
    const { descricao, startDate, endDate } = data.data[0];
    return {
      message: descricao,
      startDate,
      endDate,
      error: null
    };
  }

  return { message: '', startDate: null, endDate: null, error: null };
};



export const getModalChecklists = async () => {
  const { data, error } = await getStrapiData('/content/requirements-modals?populate=*');

  if (error) {
    return { data: null, error: null };
  }

  return { data, error: null };
};

export const getRequirementsModalContent = async () => {
  const { data, error } = await getModalChecklists();

  if (error) {
    return { data: null, error: null };
  }

  if (!data || !data.data || data.data.length === 0) {
    return { data: null, error: null };
  }

  try {
    const modalData = data.data[0];

    console.log('modalData', modalData);

    const requirementItems = (modalData.opcoes_checklist || [])
      .filter(item => item.texto && item.texto.trim() !== '')
      .map((item, index) => {
        const keyMap = ['machinesUpdated', 'fuelRegistered', 'vipRegistered'];
        return {
          id: item.id.toString(),
          key: keyMap[index] || `requirement_${item.id}`,
          label: item.texto,
          ordem: item.ordem,
          texto_balao: item.texto_balao
        };
      });

    const result = {
      data: {
        title: modalData.titulo,
        infoText: modalData.subtitulo,
        confirmationText: modalData.checkbox_opcional || 'Ok, minhas configurações estão todas atualizadas e não preciso mais dessa mensagem',
        backButtonText: 'Voltar mais tarde',
        continueButtonText: 'Tudo certo, vamos começar',
        exibirParaTodos: modalData.exibirParaTodos,
        controleModal: modalData.controleModal,
        limparLocalStorage: modalData.limparLocalStorage || false,
        versaoInterna: modalData.versaoInterna || '1.0.0',
        requirementItems
      },
      error: null
    };

    return result;
  } catch (err) {
    console.error('Erro ao processar dados do modal:', err);
    return { data: null, error: null };
  }
};


export const getFAQDiscount = async (offerType = null) => {
  const { data, error } = await getStrapiData('/content/faq-pages?populate=secoes.itens.respostas');
  if (error) {
    return { data: null, error: null };
  }

  // Filtrar por tipo de oferta se especificado
  if (data && data.data && offerType) {
    const filteredData = data.data.filter(item =>
      item.secoes && item.secoes.tipo_de_oferta === offerType
    );
    return { data: { ...data, data: filteredData }, error: null };
  }

  return { data, error: null };
};